import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BookView from '../views/BookView.vue'
import NoticeView from '../views/NoticeView.vue'
import CalendarView from '../views/CalendarView.vue'
import BackgroundView from '../views/BackgroundView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/post',
    name: 'post',
    component: HomeView
  },
  {
    path: '/book',
    name: 'BookView',
    component: BookView
  },
  {
    path: '/',
    name: 'NoticeView',
    component: NoticeView
  },
  {
    path: '/calendar',
    name: 'CalendarView',
    component: CalendarView
  },
  {
    path: '/background',
    name: 'BackgroundView',
    component: BackgroundView
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
